export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9411.f89baa57.jpg";